export const FETCH_LICENSE_TYPES_REQUEST =
  'licenseTypes/FETCH_LICENSE_TYPES_REQUEST'
export const FETCH_LICENSE_TYPES_SUCCESS =
  'licenseTypes/FETCH_LICENSE_TYPES_SUCCESS'
export const FETCH_LICENSE_TYPES_FAILURE =
  'licenseTypes/FETCH_LICENSE_TYPES_FAILURE'

export const FETCH_LICENSE_TYPE_REQUEST =
  'licenseTypes/FETCH_LICENSE_TYPE_REQUEST'
export const FETCH_LICENSE_TYPE_SUCCESS =
  'licenseTypes/FETCH_LICENSE_TYPE_SUCCESS'
export const FETCH_LICENSE_TYPE_FAILURE =
  'licenseTypes/FETCH_LICENSE_TYPE_FAILURE'

export const DELETE_LICENSE_TYPE_REQUEST =
  'licenseTypes/DELETE_LICENSE_TYPE_REQUEST'
export const DELETE_LICENSE_TYPE_SUCCESS =
  'licenseTypes/DELETE_LICENSE_TYPE_SUCCESS'
export const DELETE_LICENSE_TYPE_FAILURE =
  'licenseTypes/DELETE_LICENSE_TYPE_FAILURE'

export const CREATE_LICENSE_TYPE_REQUEST =
  'licenseTypes/CREATE_LICENSE_TYPE_REQUEST'
export const CREATE_LICENSE_TYPE_SUCCESS =
  'licenseTypes/CREATE_LICENSE_TYPE_SUCCESS'
export const CREATE_LICENSE_TYPE_FAILURE =
  'licenseTypes/CREATE_LICENSE_TYPE_FAILURE'

export const UPDATE_LICENSE_TYPE_REQUEST =
  'licenseTypes/UPDATE_LICENSE_TYPE_REQUEST'
export const UPDATE_LICENSE_TYPE_SUCCESS =
  'licenseTypes/UPDATE_LICENSE_TYPE_SUCCESS'
export const UPDATE_LICENSE_TYPE_FAILURE =
  'licenseTypes/UPDATE_LICENSE_TYPE_FAILURE'

export const FETCH_DEFAULT_PREFIX_REQUEST =
  'licenseTypes/FETCH_DEFAULT_PREFIX_REQUEST'
export const FETCH_DEFAULT_PREFIX_SUCCESS =
  'licenseTypes/FETCH_DEFAULT_PREFIX_SUCCESS'
export const FETCH_DEFAULT_PREFIX_FAILURE =
  'licenseTypes/FETCH_DEFAULT_PREFIX_FAILURE'

export const UPDATE_FIELD = 'licenseTypes/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'licenseTypes/SET_DEFAULT_DATA'
